export default __webpack_public_path__ + "static/media/login-bg-48.39fcade8.jpg";